import { templateApi } from "@/core/data/api";

export default async () => {
  return await templateApi.getTemplateList({ active: true });
};
